<template>
  <div id="app">

    <GlobalHeader />

    <router-view />

    <FooterBottom />
  </div>
</template>

<script>
import GlobalHeader from '@/components/GlobalHeader'
import FooterBottom from '@/components/FooterBottom'

export default {
  name: 'App',
  components: {
    GlobalHeader,
    FooterBottom
  }
}
</script>
<style>
table {
  width: 100%;
  border-collapse: collapse;
  border-spacing: 0;
  background: #fff;
  table-layout: fixed;
}

thead {
  background: #f5f7fa;
}

th {
  padding: 14px 12px;
  font-size: 14px;
  font-weight: 600;
  color: #303133;
  text-align: center;
  border: 1px solid #ebeef5;
}

td {
  padding: 12px;
  font-size: 14px;
  color: #606266;
  text-align: center;
  border: 1px solid #ebeef5;

  overflow: hidden;
  text-overflow: ellipsis;
  white-space: nowrap;
}

img,
table {
  max-width: 100% !important;
}

.ellipsis {
  overflow: hidden;
  text-overflow: ellipsis;
  white-space: nowrap;
}

.row-list img {
  margin: 0 auto;
}

.row-list table {
  width: 100% !important;
  display: block;
  overflow-x: auto;
  border-collapse: collapse;
}

.row-list p {
  line-height: 2;
  margin: 15px 0;
}

.row-list a {
  color: rgb(53, 53, 53);
  line-height: 2;
}

.share {
  display: flex;
  align-items: center;
  flex-shrink: 0;
}

.share .share-back {
  margin-left: 10px;
  display: none;
}

@media (max-width: 576px) {
  .share-back {
    display: block !important;
  }

  h1 {
    font-size: 20px;
  }

  p {
    font-size: 12px;
  }
}
</style>